module.exports = __webpack_public_path__ + "static/SHOWREEL_BLACK-aa0559e3dae3a5b5f67c89ca5d79b64b.mp4";